import { render } from "./InvoiceApprovalStatusChip.vue?vue&type=template&id=d0897008"
import script from "./InvoiceApprovalStatusChip.vue?vue&type=script&lang=js"
export * from "./InvoiceApprovalStatusChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__